import React from 'react'
import Configurator from '../../configurator'
import { withRouter } from '../../validator'
import { getUrlParameter } from '../../admin/actions'
import { Redirect } from 'react-router'
import OverlayLoader from '../shared/overlay-loader'
import setLoggedUser from '../../admin/actions/set-logged-user'

@withRouter()
export default class RemoteLogged extends Configurator {
    state = {
        redirect: null,
    }

    /**
     * On mount set login based on incoming params
     */
    componentDidMount() {
        this.setLogin()
    }

    /**
     * Set redirect
     *
     * @param {string} redirect
     * @param {boolean} force - if true, link will be JS force redirected
     */
    setRedirect = (redirect, force = false) => {
        if (force) {
            window.location.href = redirect
            return
        }

        this.setState({ redirect })
    }

    /**
     * Set login
     *
     * @return {Promise}
     */
    setLogin = () => {
        const urlTokens = getUrlParameter('sntokens')

        if (!urlTokens) {
            return this.setRedirect('/')
        }

        const redirectPage = window.atob(getUrlParameter('redirect'))
        const tokens = JSON.parse(window.atob(urlTokens))

        return setLoggedUser(tokens, redirectPage && redirectPage !== '' ? redirectPage : '/')
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const { redirect } = this.state

        if (redirect) {
            return <Redirect to={redirect} />
        }

        return <OverlayLoader />
    }
}
